import React from "react";
import { NavLink } from "react-router-dom";

export interface TabItem {
  to: string;
  label: string;
  icon?: React.ComponentType<{ size?: number; className?: string }>;
  end?: boolean;
}

/** Route-aware tab bar (underline style). */
export function Tabs({ tabs }: { tabs: TabItem[] }) {
  return (
    <nav className="flex items-center gap-xs border-b border-border/70 mb-md overflow-x-auto">
      {tabs.map((t) => {
        const Icon = t.icon;
        return (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              [
                "flex items-center gap-xs px-sm py-sm text-sm whitespace-nowrap border-b-2 -mb-[1px] rounded-t-md transition-colors",
                isActive
                  ? "border-brand text-brand font-medium"
                  : "border-transparent text-textLight hover:text-text hover:bg-brand/5",
              ].join(" ")
            }
          >
            {Icon && <Icon size={15} />}
            {t.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
